module.exports = __webpack_public_path__ + "public/images/slider/slide-3.1ca02f961c873a48df518d580aa7f8c9.jpg";